// Port de app/(tabs)/livroOcorrencia.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const LivroOcorrenciaScreen = lazy(() => import("@/screens/LivroOcorrencia"));

export default function LivroOcorrenciaRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <LivroOcorrenciaScreen />
    </Carregando>
  ) : null;
}
